export default __webpack_public_path__ + "static/media/job_offer18_xl.5b301fc8.jpg";